import styled from "styled-components";

export const St = {
  MainPage: styled.main`
    position: relative;
  `,

  ContentContainer: styled.section`
    width: 76rem;
    margin: 0 auto;
  `,
};
